"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZIndex = void 0;
var ZIndex;
(function (ZIndex) {
    ZIndex["Below"] = "u-z-below";
    ZIndex["Base"] = "u-z-base";
    ZIndex["Bottom"] = "u-z-bottom";
    ZIndex["Middle"] = "u-z-middle";
    ZIndex["Top"] = "u-z-top";
    ZIndex["Neg"] = "u-z--1";
    ZIndex["Zero"] = "u-z-0";
    ZIndex["One"] = "u-z-1";
    ZIndex["Hundred"] = "u-z-100";
    ZIndex["Thousand"] = "u-z-1000";
})(ZIndex = exports.ZIndex || (exports.ZIndex = {}));
//# sourceMappingURL=ZIndex.js.map